export default {
    methods: {
        convertStonesAndPoundsToKilos(stones, pounds, creating) {
            
            if (!stones && !pounds) {
                if (creating) {
                    this.form.weight = null
                } else {
                    this.patient.weight = null
                }
                return
            }
            
            var stoneInKilos = 6.350
            var poundInKilos = 0.4536
            stones = stones * stoneInKilos
            pounds = pounds * poundInKilos 

            if(creating) {
                this.form.weight = (stones + pounds).toFixed(2)
            } else {
                this.patient.weight = (stones + pounds).toFixed(2)
            }
        }, 

        convertKilosToStonesAndPounds(kg) {

            if (!kg) {
                this.stones = null
                this.pounds = null
                return null
            }

            var weightInPounds = kg/0.4536
            var stones = Math.floor(weightInPounds/14)
            var pounds = weightInPounds - (14*stones)

            this.stones = Math.round(stones)
            this.pounds = Math.round(pounds)

            return `${Math.round(stones)}st ${Math.round(pounds)}lbs`
        },

        convertKilosToStones(kg) {

            if (!kg) {
                return null
            }

            var weightInPounds = kg/0.4536
            var stones = Math.floor(weightInPounds/14)

            return Math.round(stones)
        },

        convertKilosToPounds(kg) {

            if (!kg) {
                return null
            }

            var weightInPounds = kg/0.4536
            var stones = Math.floor(weightInPounds/14)
            var pounds = weightInPounds - (14*stones)

            return Math.round(pounds)
        },

        convertFeetAndInchesToCentimetres(feet, inches, creating) {

            if (!feet && !inches) {
                if (creating) {
                    this.form.height = null
                } else {
                    this.patient.height = null
                }
                return
            }

            var feetInCm = 30.48
            var inchInCm = 2.54
            feet = feet * feetInCm
            inches = inches * inchInCm 

            if(creating) {
                this.form.height = Math.round(feet + inches)
            } else {
                this.patient.height = Math.round(feet + inches)
            }
        },

        convertCentimetresToFeetAndInches(cm) {

            if (!cm) {
                this.feet = null
                this.inches = null
                return null
            }

            var lengthInInches = cm/2.54
            var feet = Math.floor(lengthInInches/12)
            var inch = lengthInInches - (12*feet)

            this.feet = feet
            this.inches = Math.round(inch)

            return `${feet}ft ${Math.round(inch)}in`
        },

        convertCentimetresToFeet(cm) {

            if (!cm) {
                return null
            }

            var lengthInInches = cm/2.54
            var feet = Math.floor(lengthInInches/12)
            
            return feet
        },

        convertCentimetresToInches(cm) {

            if (!cm) {
                return null
            }

            var lengthInInches = cm/2.54
            var feet = Math.floor(lengthInInches/12)
            var inch = lengthInInches - (12*feet)

            return Math.round(inch)
        }
    }
}